import React from "react";
import PropertyDetailsBuilderGeneral from "./tabs/PropertyDetailsBuilderGeneral";
import PropertyDetailsBuilderAccount from "./tabs/PropertyDetailsBuilderAccount";
import PropertyDetailsBuilderPricing from "./tabs/PropertyDetailsBuilderPricing";
import PropertyDetailsBuilderLocks from "./tabs/PropertyDetailsBuilderLocks";
import PropertyDetailsBuilderMenu from "./tabs/PropertyDetailsBuilderMenu";
import ReservationSettingBuilderGeneral from "../ReservationSettingBuilder/tabs/ReservationSettingBuilderGeneral";
import PropertyDetailsBuilderPaymentGateway from "./tabs/PropertyDetailsBuilderPaymentGateway";
import PropertyDetailsBuilderAPIConnections from "./tabs/PropertyDetailsBuilderAPIConnections";
import PropertyDetailsBuilderChannelPartnersAccountDetials from './tabs/PropertyDetailsBuilderChannelPartnersAccountDetials';
import PropertyDetailsBuilderRuQueueLogs from './tabs/PropertyDetailsBuilderRuQueueLogs';
import PropertyDetailsBuilderImports from './tabs/PropertyDetailsBuilderImports';
import PropertyDetailsBuilderTwilio from './tabs/PropertyDetailsBuilderTwilio';
import PropertyDetailsBuilderInternalEmailsTasks from './tabs/PropertyDetailsBuilderInternalEmailsTasks';


export default class PropertyDetailsBuilderTabContent extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="tab-content">
        <PropertyDetailsBuilderGeneral {...this.props} />
        <PropertyDetailsBuilderChannelPartnersAccountDetials {...this.props} />

        {this.props.superadmin ? (
          <PropertyDetailsBuilderAccount {...this.props} />
        ) : null}

        {this.props.superadmin ? (
          <PropertyDetailsBuilderMenu {...this.props} />
        ) : null}

        {!this.props.superadmin ? (
          <ReservationSettingBuilderGeneral {...this.props} />
        ) : null}

        {this.props.superadmin &&
        this.props.property &&
        this.props.property.id ? (
          <PropertyDetailsBuilderPricing {...this.props} />
        ) : null}

        {this.props.superadmin &&
        this.props.property &&
        this.props.property.id ? (
          <PropertyDetailsBuilderPaymentGateway {...this.props} />
        ) : null}

        {this.props.property && this.props.property.id ? (
          <PropertyDetailsBuilderLocks {...this.props} />
        ) : null}
        
        {this.props.superadmin &&
        this.props.property &&
        this.props.property.id ? (
          <PropertyDetailsBuilderRuQueueLogs {...this.props} />
        ) : null}
        
        {this.props.superadmin ? (
          <PropertyDetailsBuilderAPIConnections {...this.props} />
          ) : null}
          
        {this.props.superadmin &&
        this.props.property &&
        this.props.property.id ? (
          <PropertyDetailsBuilderImports {...this.props} />
        ) : null}

        {this.props.superadmin &&
        this.props.property &&
        this.props.property.id ? (
          <PropertyDetailsBuilderTwilio {...this.props} />
        ) : null}

        {this.props.superadmin &&
        this.props.property &&
        this.props.property.id ? (
          <PropertyDetailsBuilderInternalEmailsTasks {...this.props} />
        ) : null}
      </div>
    );
  }
}
